var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketingCopiesOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0781 11.9936C25.0781 18.6175 19.7084 23.9873 13.0845 23.9873C6.46055 23.9873 1.09082 18.6175 1.09082 11.9936C1.09082 5.36973 6.46055 0 13.0845 0C19.7084 0 25.0781 5.36973 25.0781 11.9936ZM22.515 11.9938C22.515 17.2026 18.2924 21.4251 13.0837 21.4251C7.87489 21.4251 3.65234 17.2026 3.65234 11.9938C3.65234 6.78505 7.87489 2.5625 13.0837 2.5625C18.2924 2.5625 22.515 6.78505 22.515 11.9938Z",
    fill: "#09A5F5",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0073 11.9939C20.0073 15.8177 16.9075 18.9175 13.0837 18.9175C9.25995 18.9175 6.16016 15.8177 6.16016 11.9939C6.16016 8.17011 9.25995 5.07031 13.0837 5.07031C16.9075 5.07031 20.0073 8.17011 20.0073 11.9939ZM17.4997 11.994C17.4997 14.4328 15.5226 16.4098 13.0838 16.4098C10.645 16.4098 8.66797 14.4328 8.66797 11.994C8.66797 9.55517 10.645 7.57812 13.0838 7.57812C15.5226 7.57812 17.4997 9.55517 17.4997 11.994Z",
    fill: "#09A5F5",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0838 13.902C14.1376 13.902 14.9919 13.0478 14.9919 11.994C14.9919 10.9402 14.1376 10.0859 13.0838 10.0859C12.03 10.0859 11.1758 10.9402 11.1758 11.994C11.1758 13.0478 12.03 13.902 13.0838 13.902Z",
    fill: "#09A5F5",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1339 4.47062L13.4112 12.2665H13.3567L12.8115 11.7213V11.6668L21.5342 3.81641H21.5887L22.0793 4.36157C22.1339 4.41609 22.1339 4.41609 22.1339 4.47062Z",
    fill: "#09A5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.934 5.01529L17.7721 7.85011L17.3359 5.56046L20.4979 2.72559L20.934 5.01529Z",
    fill: "#09A5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0076 8.50465L23.1696 5.7243L20.9344 5.01562L17.7725 7.85044L20.0076 8.50465Z",
    fill: "#09A5F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingCopiesOutline);
export default __webpack_public_path__ + "static/media/marketing_copies_outline.21af9c3f08d9d8e6476336b958debb11.svg";
export { ForwardRef as ReactComponent };